import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const RamblerAnalytics = ({ service, isPageLoading, className }) => {
	useEffect(() => {
		/* eslint-disable */
		(window._top100q = window._top100q || []).push(() => {
			const options = {
				project: service.analyticsId,
				element: 'top100_widget',
				attributes_dataset: [
					'best',
					'compilation-1',
					'compilation-2',
					'compilation-3',
					'compilation-4',
					'catalog',
					'player',
					'reviews',
					'themes',
					'streaming-platforms'
				]
			};
			try {
				window.top100Counter = new top100(options);
			} catch (e) {}
		});
		/* eslint-enable */
	}, []);

	useEffect(() => {
		if (!isPageLoading) {
			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.async = true;
			script.src = `${
				document.location.protocol === 'https:' ? 'https:' : 'http:'
			}//st.top100.ru/top100/top100.js`;

			const head = document.head || document.getElementsByTagName('head')[0];
			head.appendChild(script);
		}
	}, [isPageLoading]);

	return (
		<div className={className}>
			<span id="top100_widget" />
		</div>
	);
};

RamblerAnalytics.propTypes = {
	service: PropTypes.shape({
		analyticsId: PropTypes.number.isRequired
	}).isRequired,
	isPageLoading: PropTypes.bool.isRequired,
	className: PropTypes.string
};

export default RamblerAnalytics;
